import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'COPItem'

const GetAll = (companyId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${companyId}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}`, data, config)
const Delete = (id, data = {}, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/${id}`, data, config)

const COPItemRepository = {
  GetAll,
  Update,
  Create,
  Delete
}

export default COPItemRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/copitem.js